// import createCachedSelector from 're-reselect';

import { emptyString } from 'constants/emptyConst';

const emptyOfferAssetClient = {
  generalData: {
    isExternal: false
  },
  addresses: [],
  contactData: {},
  contactMode: {},
  dealerContactInfos: [],
  dealerContactEmails: [],
  dealerContactPhones: [],
  agreesWithPersonalDataUse: false,
  agreesWithPersonalDataUseReadOnly: false
};

const emptyClientSummary = {
  hasPartnerType: false,
  partnerName: emptyString,
  contactData: {
    email: emptyString,
    phone: emptyString
  }
};

const getOfferPartner = state => state.entities.offerPartners[state.currentOffer.assetClientData.client.partnerId] || emptyOfferAssetClient;
export const getOfferAssetClientData = state => state.currentOffer.assetClientData;
export const getOfferAssetClient = state => getOfferAssetClientData(state).client;
export const getOfferAssetClientIsLoaded = state => getOfferAssetClient(state).isLoaded;

export const getFullOfferAssetClient = state => {
  const { partnerId, isLoaded } = getOfferAssetClient(state);
  if (partnerId === null || !isLoaded) {
    return emptyOfferAssetClient;
  }
  const client = getOfferPartner(state);
  return client;
};

export const getClientSummary = client => {
  if (!client.partnerType) return emptyClientSummary;
  const { generalData, contactData, partnerType } = client;

  let partnerName = emptyString;
  if (partnerType?.typeCheck?.isPF) {
    if (generalData?.firstName) partnerName = generalData?.firstName + ' ';
    if (generalData?.lastName) partnerName += generalData?.lastName;
  } else if (generalData?.partnerName) {
    partnerName = generalData?.partnerName;
  }

  return {
    hasPartnerType: true,
    partnerName: partnerName,
    contactData: {
      email: contactData?.email,
      phone: contactData?.phone
    }
  };
};

export const getPartnerByUniqueId = state => {
  const client = getOfferAssetClient(state);
  if (!client.loadedByUniqueId) {
    const assetClient = getFullOfferAssetClient(state);
    return assetClient;
  }

  return state.clientData.clients.byUniqueId[client.loadedByUniqueId] || emptyOfferAssetClient;
};

export const getFilteredPartnerTypes = (state, isFacilityFrame) => {
  if (isFacilityFrame) {
    const partnerTypes = state.clientData.partnerTypes.filter(x => !x.typeCheck.isPF);
    return partnerTypes;
  }

  return state.clientData.partnerTypes || [];
};
